export default "__VITE_ASSET__DDucwkqd__"